import {
  Badge,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Loader,
  LoadingOverlay,
  Menu,
  MultiSelect,
  rem,
  Select,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import {
  MRT_ColumnDef,
  MRT_RowSelectionState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import * as React from "react";
import { useEffect, useState } from "react";
import {
  _timerDelayClick,
  repositoryDelivery,
  repositoryMdm,
  repositoryPos,
} from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { paginationBase } from "../../../_base/model/_base/BaseTable";
import {
  formatDateNotTimeZone,
  formatDateTransfer,
} from "../../../common/FormatDate/FormatDate";
import { _localization } from "../../../config/location";
import { TblDMExpense } from "../../../model/TblDMExpense";
import {
  IconBarcode,
  IconBrandBootstrap,
  IconBuildingSkyscraper,
  IconBuildingWarehouse,
  IconCalendar,
  IconCaretDown,
  IconClipboardData,
  IconFileExport,
  IconFileUpload,
  IconPhone,
  IconSearch,
  IconTagStarred,
} from "@tabler/icons-react";
import {
  useDebouncedState,
  useDebouncedValue,
  useDisclosure,
} from "@mantine/hooks";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { green } from "../../../const/variables";
import {
  changeSearchValue,
  getValueById,
} from "../../../_base/helper/FunctionHelper";
import { DatePickerInput } from "@mantine/dates";
import { getBranchSelectMdm } from "../../../service/getSelectApi";
import { MessageResponse } from "../../../model/MessageResponse";
import { BASE_API_DELIVERY } from "../../../config";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";

type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

const ExportOrReExport = () => {
  //data and fetching state
  const navigate = useNavigate();
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<TblDMExpense[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  //table state
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  // const [keySearch, setKeySearch] = useState<string>("");
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const [pagination, setPagination] = useState(paginationBase);
  const [visible, { toggle, close, open }] = useDisclosure(false);
  //count
  const [timeLeft, setTimeLeft] = useState(60);
  const [isCounting, setIsCounting] = useState(false);
  //select
  const [trangThaiDhSelect] = useState<ComboboxItem[]>([
    { label: "Đơn hàng hoàn thành", value: "DON_HANG_HOAN_THANH" },
    { label: "Kho xuất hàng", value: "KHO_XUAT_HANG" },
    { label: "Hủy phân công KTKT", value: "HUY_PHAN_CONG_KTKT" },
    { label: "Thành công", value: "THANH_CONG" },
    { label: "Test lỗi", value: "TEST_LOI" },
    { label: "Test OK", value: "TEST_OK" },
    { label: "Đã phân công giao vận", value: "DA_PHAN_CONG_GV" },
    { label: "KTKT đang kiểm tra", value: "KTKT_DANG_KIEM_TRA" },
    { label: "Giao vận đến nơi", value: "GV_DEN_NOI" },
    { label: "Đã phân công KTKT", value: "DA_PHAN_CONG_KTKT" },
  ]);
  const loaiGdKho = [
    { label: "Nhập đổi trả", value: "NHAP_DOI_TRA" },
    { label: "Xuất bán", value: "XUAT_BAN" },
    { label: "Xuất đổi trả", value: "XUAT_DOI_TRA" },
  ];
  const [warrantyTerm] = useState<ComboboxItem[]>([
    { label: "0 tháng", value: "0" },
    { label: "3 tháng", value: "3" },
    { label: "6 tháng", value: "6" },
    { label: "12 tháng", value: "12" },
    { label: "18 tháng", value: "18" },
    { label: "36 tháng", value: "36" },
    { label: "60 tháng", value: "60" },
  ]);
  const [dataBranchSelect, setDataBranchSelect] = useState<ComboboxItem[]>([]);
  const [dataVendorSelect, setDataVendorSelect] = useState<ComboboxItem[]>([]);
  const [dataCatSegment4d, setDataCatSegment4d] = useState<ComboboxItem[]>([]);

  const [searchCatSegment4d, setSearchCatSegment4d] = useState("");
  const [debouncedCatSegment4d] = useDebouncedValue(searchCatSegment4d, 500);

  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";

  // Bộ lọc truyền qua URL khi điều hướng từ màn Báo cáo tỷ lệ hàng lỗi bảo hành.
  // Khi có params từ URL thì ưu tiên dùng và bỏ qua bộ lọc đã ghim trong session
  // để tránh dính lại bộ lọc cũ.
  const [searchParams] = useSearchParams();
  const paramStartDate = searchParams.get("startDate");
  const paramEndDate = searchParams.get("endDate");
  const paramMaSp = searchParams.get("MaSp");
  const hasParamSearch = Boolean(paramStartDate || paramEndDate || paramMaSp);

  const [search, setSearch] = useState<any>({
    startDate: hasParamSearch
      ? (paramStartDate ?? "")
      : _searchJson && checkedPinSearch
        ? _searchJson?.startDate
        : new Date(
            new Date(new Date().setMonth(new Date().getMonth() - 1)).getTime() +
              7 * 60 * 60 * 1000,
          )?.toISOString(),
    endDate: hasParamSearch
      ? (paramEndDate ?? "")
      : _searchJson && checkedPinSearch
        ? _searchJson?.endDate
        : new Date(new Date().getTime() + 7 * 60 * 60 * 1000)?.toISOString(),
    idCn:
      !hasParamSearch && _searchJson && checkedPinSearch
        ? _searchJson?.idCn
        : "",
    trangThaiDh:
      !hasParamSearch && _searchJson && checkedPinSearch
        ? _searchJson?.trangThaiDh
        : "",
    loaiGdKho:
      !hasParamSearch && _searchJson && checkedPinSearch
        ? _searchJson?.loaiGdKho
        : "",
    idNcc:
      !hasParamSearch && _searchJson && checkedPinSearch
        ? _searchJson?.idNcc
        : "",
    // fromWarrantyDue: "",
    // toWarrantyDue: "",
    MaChungs:
      !hasParamSearch && _searchJson && checkedPinSearch
        ? (_searchJson?.MaChungs ?? [])
        : [],
    SdtKh:
      !hasParamSearch && _searchJson && checkedPinSearch
        ? _searchJson?.SdtKh
        : "",
  });

  const [keySearch, setKeySearch] = useDebouncedState<string>(
    !hasParamSearch && _searchJson && checkedPinSearch
      ? _searchJson?.keySearch
      : "",
    300,
  );
  const [MaSp, setMaSp] = useDebouncedState<string>(
    hasParamSearch
      ? (paramMaSp ?? "")
      : _searchJson && checkedPinSearch
        ? _searchJson?.MaSp
        : "",
    300,
  );
  const [Serial, setSerial] = useDebouncedState<string>(
    !hasParamSearch && _searchJson && checkedPinSearch
      ? _searchJson?.Serial
      : "",
    300,
  );

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "tenCn",
        header: "Chi nhánh",
      },
      {
        accessorKey: "maSp",
        header: "Mã sản phẩm",
        Cell: ({ renderedCellValue }: any) =>
          renderedCellValue === null ? null : (
            <Badge variant="light">{renderedCellValue}</Badge>
          ),
      },
      {
        accessorKey: "serial",
        header: "Serial",
      },
      {
        accessorKey: "tenSp",
        header: "Tên sản phẩm",
        size: 425,
      },
      {
        accessorKey: "maChung",
        header: "Mã chủng",
      },
      {
        accessorKey: "tenChung",
        header: "Tên chủng",
        size: 225,
      },
      {
        accessorKey: "dvt",
        header: "Đơn vị tính",
        size: 150,
      },
      {
        accessorKey: "thoiGianBh",
        header: "Thời hạn bảo hành",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {renderedCellValue}
          </Text>
        ),
        size: 200,
      },
      {
        accessorKey: "tenNcc",
        header: "NCC sản phẩm",
        size: 400,
      },
      {
        accessorKey: "ctDonHang",
        header: "Chứng từ đơn hàng",
        Cell: ({ renderedCellValue, row }) => (
          <Tooltip label="Xem chi tiết">
            <Badge
              radius="sm"
              variant="dot"
              color={renderedCellValue === null ? "red" : green.base}
              onDoubleClick={() => handleCheckView(row)}
              style={{ cursor: "pointer" }}
            >
              {renderedCellValue}
            </Badge>
          </Tooltip>
        ),
        size: 200,
      },
      {
        accessorKey: "trangThaiDh",
        header: "Trạng thái đơn hàng",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {getValueById(
              renderedCellValue?.toString() ?? "",
              trangThaiDhSelect,
              "label",
            )}
          </Text>
        ),
        size: 200,
      },
      {
        accessorKey: "ngayGd",
        header: "Ngày giao dịch",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "ctKho",
        header: "Chứng từ kho",
        Cell: ({ renderedCellValue, row }) => (
          <Tooltip label="Xem chi tiết">
            <Badge
              radius="sm"
              variant="dot"
              color={renderedCellValue === null ? "red" : green.base}
              onDoubleClick={() =>
                detailOutWard(
                  String(renderedCellValue),
                  row.original.loaiGdKho,
                  true,
                )
              }
              style={{ cursor: "pointer" }}
            >
              {renderedCellValue}
            </Badge>
          </Tooltip>
        ),
      },
      {
        accessorKey: "loaiGdKho",
        header: "Loại giao dịch kho",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {getValueById(
              renderedCellValue?.toString() ?? "",
              loaiGdKho,
              "label",
            )}
          </Text>
        ),
        size: 200,
      },
      {
        accessorKey: "maKh",
        header: "Mã khách hàng",
        Cell: ({ renderedCellValue }: any) =>
          renderedCellValue === null ? null : (
            <Badge variant="light">{renderedCellValue}</Badge>
          ),
      },
      {
        accessorKey: "tenKh",
        header: "Tên khách hàng",
      },
      {
        accessorKey: "sdt",
        header: "Số điện thoại",
      },
      {
        accessorKey: "dcKh",
        header: "Địa chỉ khách hàng",
        size: 400,
      },
    ],
    [],
  );

  const startCountdown = () => {
    if (!isCounting) {
      setTimeLeft(_timerDelayClick);
      setIsCounting(true);
    }
  };

  const handleChangeSearchValue = (value: string, key: string) => {
    setSearch((prevData: any) => ({ ...prevData, [key]: value }));
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);

    let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
      pagination.pageSize
    }`;

    if (search.startDate.length > 0) {
      url += `&StartDate=${search.startDate}`;
    }

    if (search.endDate.length > 0) {
      url += `&EndDate=${search.endDate}`;
    }

    if (search.idCn.length > 0) {
      url += `&IdCn=${search.idCn}`;
    }

    if (search.trangThaiDh.length > 0) {
      url += `&TrangThaiDh=${search.trangThaiDh}`;
    }

    if (search.SdtKh.length > 0) {
      url += `&SdtKh=${search.SdtKh}`;
    }

    if (search.loaiGdKho.length > 0) {
      url += `&LoaiGdKho=${search.loaiGdKho}`;
    }

    if (search.idNcc.length > 0) {
      url += `&IdNcc=${search.idNcc}`;
    }

    if (MaSp.length > 0) {
      url += `&MaSp=${MaSp}`;
    }

    if (Serial?.trim()?.length > 0) {
      url += `&Serial=${Serial}`;
    }

    // if (search.fromWarrantyDue.length > 0) {
    //   url += `&FromWarrantyDue=${search.fromWarrantyDue}`;
    // }

    // if (search.toWarrantyDue.length > 0) {
    //   url += `&ToWarrantyDue=${search.toWarrantyDue}`;
    // }

    if (search.MaChungs.length > 0) {
      url += search.MaChungs?.map((item: any) => `&MaChungs=${item}`).join("");
    }

    if (keySearch.length > 0) {
      url += `&KeySearch=${keySearch}`;
    }

    try {
      const response = await repositoryDelivery.get(
        `/api/v1/SaleSerialReport/get-list${url}`,
      );
      if (response && response.success) {
        let result = response.data;
        setData(result);
        setRowCount(response.totalCount ?? 0);
        setSelectIds([]);
        table.resetRowSelection();
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...search,
          keySearch: keySearch,
          MaSp: MaSp,
          Serial: Serial,
        }),
      );
    }
    startCountdown();
  };

  const handleExportData = async () => {
    open();
    try {
      let url = `/api/v1/SaleSerialReport/export-sale-serial?Skip=${
        pagination?.pageIndex * pagination?.pageSize
      }&Take=${pagination.pageSize}`;

      if (search.startDate.length > 0) {
        url += `&StartDate=${search.startDate}`;
      }

      if (search.endDate.length > 0) {
        url += `&EndDate=${search.endDate}`;
      }

      if (search.idCn.length > 0) {
        url += `&IdCn=${search.idCn}`;
      }

      if (search.trangThaiDh.length > 0) {
        url += `&TrangThaiDh=${search.trangThaiDh}`;
      }

      if (search.loaiGdKho.length > 0) {
        url += `&LoaiGdKho=${search.loaiGdKho}`;
      }

      if (search.SdtKh.length > 0) {
        url += `&SdtKh=${search.SdtKh}`;
      }

      if (search.idNcc.length > 0) {
        url += `&IdNcc=${search.idNcc}`;
      }

      if (search.MaChungs.length > 0) {
        url += search.MaChungs?.map((item: any) => `&MaChungs=${item}`).join(
          "",
        );
      }

      if (MaSp.length > 0) {
        url += `&MaSp=${MaSp}`;
      }

      if (Serial.length > 0) {
        url += `&Serial=${Serial}`;
      }

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch}`;
      }

      const _url = BASE_API_DELIVERY + url;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
        },
      });

      if (!response.ok) {
        NotificationExtension.Fails("Export Excel thất bại !");
      } else {
        const blob = await response.blob();
        const urlss = window.URL.createObjectURL(blob);
        const _name = new Date().toISOString().slice(0, 10);
        let filename =
          "bao_cao_serial_xuat_ban_hoac_nhap_lai" + _name + ".xlsx";
        const link = document.createElement("a");
        link.href = urlss;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        NotificationExtension.Success("Export Excel thành công !");
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  const handleCheckView = async (row: any) => {
    const url = `/api/v1/CreateSellItem/details?orderNumber=${row.original.ctDonHang}`;
    const response = await repositoryPos.get<MessageResponse<any>>(url);
    if (response && response.success) {
      if (row.original.ctDonHang.includes("DT")) {
        navigate("/sell/view-order-return", {
          state: {
            id: row.original.id || undefined,
            orderNumber: row.original.ctDonHang || undefined,
            orderType: row.original.orderType || undefined,
            actionType: "view",
          },
        });
      } else {
        navigate("/sell/view-order", {
          state: {
            id: row.original.id || undefined,
            orderNumber: row.original.ctDonHang || undefined,
            orderType: row.original.orderType || undefined,
            actionType: "view",
          },
        });
      }
    }
  };

  const detailOutWard = (
    id: string | number,
    type: string | number | null,
    isLocked: boolean,
  ) => {
    navigate("/warehouse-config/detail-warehouse-out-ward", {
      state: { transactionCode: id, type: type, isLocked: isLocked },
    });
  };

  const fetchDataCatSegment4d = async () => {
    let url = `/api/v1/TblCatSegment4d/get-list?Skip=0&Take=30`;

    if (searchCatSegment4d.length > 0) {
      url += `&KeySearch=${searchCatSegment4d}`;
    }

    const res = await repositoryPos.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const dataAPI = res?.data
        ?.filter((item: any) => item.codeString !== null)
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: item.codeString?.toString(),
        }));
      setDataCatSegment4d(dataAPI);
    }
  };

  const fetchDataBranchSelect = async () => {
    const getData = await getBranchSelectMdm();
    setDataBranchSelect(
      getData
        .filter(
          (item) =>
            item.value != null && item.text != null && item.value !== "-1",
        )
        .map((item) => ({
          value: item.value,
          label: item.text,
        })),
    );
  };

  const getDataVendorSelect = async () => {
    const getData = await repositoryMdm.get<MessageResponse<any>>(
      "/api/v1/TblVendor/get-all",
    );

    if (getData && getData?.success) {
      const result = getData.data;
      setDataVendorSelect(
        result
          ?.filter(
            (item: any) => item.vendorName != null && item.vendorCode != null,
          )
          ?.map((item: any) => ({
            value: item.id?.toString(),
            label: `${item.vendorCode} - ${item.vendorName}`,
          })),
      );
    }
  };

  useEffect(() => {
    let timer: ReturnType<typeof setInterval>;
    if (isCounting && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      setIsCounting(false);
    }
    return () => clearInterval(timer);
  }, [isCounting, timeLeft]);

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  useEffect(() => {
    fetchDataBranchSelect();
    getDataVendorSelect();
  }, []);

  useEffect(() => {
    fetchData();
  }, [pagination, deleteViewStatus]);

  useEffect(() => {
    fetchDataCatSegment4d();
  }, [debouncedCatSegment4d]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 160 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (140 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, [height]);

  const getColumnPinningStorage = () => {
    const columnPinningStorage = localStorage.getItem(
      "columnPinningExportOrReExport",
    );
    return columnPinningStorage
      ? JSON.parse(columnPinningStorage)
      : {
          right: ["action"],
        }; // Giá trị mặc định
  };

  // Lưu columnPinning vào state
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(
    getColumnPinningStorage(),
  );

  // Hàm lưu vào localStorage
  useEffect(() => {
    localStorage.setItem(
      "columnPinningExportOrReExport",
      JSON.stringify(columnPinning),
    );
  }, [columnPinning]);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    enableColumnActions: true,
    enableColumnFilters: false,
    enableSorting: false,
    positionToolbarAlertBanner: "bottom",
    //add custom action buttons to top-left of top toolbar
    renderTopToolbarCustomActions: ({ table }) => (
      <div ref={headerRef} style={{ width: "100%" }}>
        <Flex wrap={"wrap"} justify={"space-between"}>
          <_breadcrumb></_breadcrumb>
          <Menu shadow="md" width={200}>
            <Menu.Target>
              <Button
                rightSection={
                  <IconCaretDown style={{ width: rem(14), height: rem(14) }} />
                }
              >
                Chức năng
              </Button>
            </Menu.Target>

            <Menu.Dropdown>
              <Menu.Item
                leftSection={
                  <IconFileExport style={{ width: rem(14), height: rem(14) }} />
                }
                onClick={() => handleExportData()}
              >
                Export Excel
              </Menu.Item>
              <Tooltip label={"Chức năng đang update"}>
                <Menu.Item
                  leftSection={
                    <IconFileUpload
                      style={{ width: rem(14), height: rem(14) }}
                    />
                  }
                >
                  Import Excel
                </Menu.Item>
              </Tooltip>
            </Menu.Dropdown>
          </Menu>
        </Flex>
        <Grid mt={10}>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Từ ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                search.startDate.length > 0
                  ? new Date(search.startDate ?? "")
                  : null
              }
              onChange={(e) => {
                handleChangeSearchValue(
                  e ? formatDateNotTimeZone(e ?? "") : "",
                  "startDate",
                );
              }}
              leftSection={<IconCalendar color="#15aabf" />}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Đến ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                search.endDate.length > 0
                  ? new Date(search.endDate ?? "")
                  : null
              }
              onChange={(e) => {
                handleChangeSearchValue(
                  e ? formatDateNotTimeZone(e ?? "") : "",
                  "endDate",
                );
              }}
              leftSection={<IconCalendar color="#15aabf" />}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Chi nhánh - Địa điểm nhận hàng"
              value={search.idCn || null}
              data={dataBranchSelect}
              searchable
              clearable
              leftSection={<IconBrandBootstrap color="#15aabf" />}
              nothingFoundMessage={"Không tìm thấy dữ liệu !"}
              onChange={(e) => {
                handleChangeSearchValue(e?.toString() ?? "", "idCn");
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Trạng thái đơn hàng"
              value={search.trangThaiDh || null}
              data={trangThaiDhSelect}
              searchable
              clearable
              leftSection={<IconClipboardData color="#15aabf" />}
              nothingFoundMessage={"Không tìm thấy dữ liệu !"}
              onChange={(e) => {
                handleChangeSearchValue(e?.toString() ?? "", "trangThaiDh");
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Loại giao dịch kho"
              value={search.loaiGdKho || null}
              data={loaiGdKho}
              searchable
              clearable
              leftSection={<IconBuildingWarehouse color="#15aabf" />}
              nothingFoundMessage={"Không tìm thấy dữ liệu !"}
              onChange={(e) => {
                handleChangeSearchValue(e?.toString() ?? "", "loaiGdKho");
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Số điện thoại khách hàng"
              type="number"
              defaultValue={search.SdtKh}
              leftSection={<IconPhone color="#15aabf" />}
              onChange={(e) =>
                handleChangeSearchValue(e.currentTarget.value, "SdtKh")
              }
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Nhà cung cấp"
              value={search.idNcc || null}
              data={dataVendorSelect}
              leftSection={<IconBuildingSkyscraper color="#15aabf" />}
              searchable
              clearable
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              comboboxProps={{ width: 425 }}
              onChange={(e) => handleChangeSearchValue(e ?? "", "idNcc")}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Nhập mã chủng"
              leftSection={<IconBarcode color="#15aabf" />}
              clearable
              searchable
              searchValue={searchCatSegment4d}
              onSearchChange={(e) => {
                setSearchCatSegment4d(e);
              }}
              data={dataCatSegment4d}
              value={search?.MaChungs}
              onChange={(e) =>
                changeSearchValue(e ? e : [], "MaChungs", setSearch)
              }
              nothingFoundMessage={"Không tìm thấy dữ liệu !"}
            />
          </Grid.Col>
          {/* <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Thời hạn bảo hành"
              data={warrantyTerm?.map((item: any) => ({
                label: `Trên ${item.label}`,
                value: item.value,
              }))}
              leftSection={<IconTagStarred color="#15aabf" />}
              onChange={(e) =>
                handleChangeSearchValue(e ?? "", "fromWarrantyDue")
              }
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Thời hạn bảo hành"
              data={warrantyTerm?.map((item: any) => ({
                label: `Dưới ${item.label}`,
                value: item.value,
              }))}
              leftSection={<IconTagStarred color="#15aabf" />}
              onChange={(e) =>
                handleChangeSearchValue(e ?? "", "toWarrantyDue")
              }
            />
          </Grid.Col> */}
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Mã sản phẩm"
              defaultValue={MaSp}
              leftSection={<IconBarcode color="#15aabf" />}
              onChange={(e) => setMaSp(e.currentTarget.value)}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Serial"
              defaultValue={Serial}
              leftSection={<IconBarcode color="#15aabf" />}
              onChange={(e) => setSerial(e.currentTarget.value)}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Nhập từ khóa"
              defaultValue={keySearch}
              leftSection={<IconSearch color="#15aabf" />}
              onChange={(e) => setKeySearch(e.currentTarget.value)}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 1 }}>
            <Button
              leftSection={<IconSearch size={14} />}
              color="blue"
              variant="outline"
              onClick={() => {
                fetchData();
              }}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
    ),
    renderToolbarInternalActions: ({ table }) => <></>,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: false,
    enableRowNumbers: true,
    getRowId: (row) => row.id,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        ...columnPinning,
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onColumnPinningChange: (newState) => {
      setColumnPinning(newState);
    },
    onRowSelectionChange: setRowSelection,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500",
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
      columnPinning,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["25", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
  });

  return (
    <>
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 5 }}
        loaderProps={{
          children: (
            <Flex direction={"column"} align="center" gap="xs">
              <Loader type="dots" size={35}></Loader>
              {/* <Title size={15}> Đang upload tài liệu...</Title> */}
              <Title size={15}> Đang xử lý....</Title>
            </Flex>
          ),
        }}
      />
      <MantineReactTable table={table} />
    </>
  );
};
export default ExportOrReExport;
